import React from "react";

type Props = {
  label?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  className?: string;
  isDefault?: boolean;
  iconButton?: React.ReactNode;
  gap?: number;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button = ({ label = "", leftIcon, rightIcon, className, isDefault = false, iconButton, gap = 8, ...props }: Props) => {
  return (
    <button
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: `${gap}px`,
        borderRadius: "4px",
        opacity: props.disabled ? 0.6 : 1,
        cursor: props.disabled ? "not-allowed" : "pointer",
        ...props.style,
      }}
      className={`${className} ${
        isDefault
          ? "text-white bg-primaryBlue hover:bg-deepBlue dark:hover:bg-freshSkyBlue dark:text-black dark:bg-brightBlue"
          : ""
      }`}
      {...props}
    >
      {iconButton ? (
        iconButton
      ) : (
        <>
          {leftIcon}
          {label}
          {rightIcon}
        </>
      )}
    </button>
  );
};

export default Button;
